import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import Button from '@/shared/components/button/Button';

interface NotificationMessageProps {
	id: string;
	title?: string;
	subtitle?: string | null;
	timeout?: number;
	error?: boolean;
	closeNotification: (id: string) => void;
}

const CLOSE_ANIMATION_MS = 250;

const NotificationMessage = ({ id, title, subtitle, timeout, error, closeNotification }: NotificationMessageProps) => {
	const [unmount, setUnmount] = useState(false);
	const timeoutRef = useRef<number | null>(null);
	const closeTimeoutRef = useRef<number | null>(null);

	const closeMessage = () => {
		if (closeTimeoutRef.current != null) {
			window.clearTimeout(closeTimeoutRef.current);
		}

		closeTimeoutRef.current = window.setTimeout(() => {
			closeNotification(id);
		}, CLOSE_ANIMATION_MS);
	};

	const startClose = () => {
		setUnmount(true);
		closeMessage();
	};

	useEffect(() => {
		if (!timeout) {
			return undefined;
		}

		timeoutRef.current = window.setTimeout(() => {
			startClose();
		}, timeout);

		return () => {
			if (timeoutRef.current != null) {
				window.clearTimeout(timeoutRef.current);
			}
			if (closeTimeoutRef.current != null) {
				window.clearTimeout(closeTimeoutRef.current);
			}
		};
	}, [timeout]);

	return (
		<div
			className={classNames('notification', {
				unmount,
			})}
		>
			<span
				className={classNames('icon', {
					'icon-incorrect-red': error,
					'icon-correct-green': !error,
				})}
			/>

			<div className="notification-info">
				<span className="main-text">{title}</span>
				{subtitle && <span className="sub-text">{subtitle}</span>}
			</div>

			<Button iconName="icon-close" onClick={startClose} type="icon-link" />
		</div>
	);
};

export default NotificationMessage;
